import { render, staticRenderFns } from "./student.vue?vue&type=template&id=84055cb6&scoped=true&"
import script from "./student.vue?vue&type=script&lang=js&"
export * from "./student.vue?vue&type=script&lang=js&"
import style0 from "./student.vue?vue&type=style&index=0&id=84055cb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84055cb6",
  null
  
)

export default component.exports